import client from '../config/axios';

export const getCountries = async (lang) => {
    const response = await client.get(`/country?lang=${lang}`);
    return response.data;
  }

  export const getRegionByCountry = async ({country, lang}) => {
    const response = await client.get(`/country/${country}?lang=${lang}`);
    return response.data;
  }

  export const getCityByCountryAndRegion = async ({country, region, lang}) => {
    const response = await client.get(`/country/${country}/${region}?lang=${lang}`);
    return response.data;
  }